import React,{memo} from "react";
import { connect } from "react-redux";
import {getLayoutFieldsData} from '../../../Containers/StepsFlowContainer/StepsFunction';
import FormInputFields from '../../../Components/FormInputFields';
import {formInputFieldsKeyRef} from '../../../Containers/ShippingContainer/ShippingFunction';
import { isSet } from '../../../Utils/CommonFunctions';
//import { updateInputValuesPayloadAction } from '../../../store/actions/StepsFlowAction';
import SwitchItems from '../../../Components/FormBuilder/Builder/FormInputs/SwitchItems';



const InnerTreeElement = (props)=>{
    const {selectedValue,item,winId} =  props;
    const variableType = isSet(item.fieldtype_name,item.field_type_name);
    
    const constantValue = {
      type:formInputFieldsKeyRef(variableType),
      label:'',
      value:selectedValue,
      isDefault:false,
      attributes:{
        id:'constant_'+item.id,
      },
      changeHandler:(val)=>props.updateValuesHandler(item.id,isSet(item.name,item.variable_name),val),
      //changeHandler:(varId,e,type)=>props.formFieldsHandler(item.id,isSet(item.name,item.variable_name),e,type),
    };
    let fieldReturnData = {isExist:false}
    try{
        fieldReturnData = getLayoutFieldsData(isSet(props.windowFields[winId].fields_with_filters.window_fields,[]),isSet(item.field_expression,''));
    }catch(e){
    }
    //console.log('constantValue==',constantValue)
      return(
        <div className='col-6' key={'innerElement_'+item.id} id={item.field_expression}>
          <div className='form-group'>
            <label>{isSet(item.name,item.variable_name)}</label>
            {(fieldReturnData.isExist===true)?
              <SwitchItems 
                key={item.id+'_field'}
                withoutBlock={true}
                validationForms={{}}
                onChangeInputAction={(varId,e,type)=>props.formFieldsHandler(item.id,isSet(item.name,item.variable_name),e,type)}
                modType={'ADDFORM'}
                item={{...fieldReturnData.fieldData,modType:'ADDFORM',selectedValue:selectedValue}}
                isLabel={false}
                section={{}}
                layoutForms={true}  />
            :
            <FormInputFields {...constantValue} />}
          </div>
        </div>
      ) 
}


const mapDispatchToProps = dispatch => {
    return {
      //updateInputValuesPayloadAction:(arr)=>dispatch(updateInputValuesPayloadAction(arr))  
    };
}


const mapStateToProps = (state) => { 
  return {
    //windowFields:state.StepsFlowReducer.windowFields,
  };
}

  const isDiffProps = (prevProps,nextProps)=>{
      if(prevProps.selectedValue===nextProps.selectedValue){
        return true;
      }
  }
  export default
    connect(
      mapStateToProps,
      mapDispatchToProps
    )((memo(InnerTreeElement)));